// extracted by mini-css-extract-plugin
export default {"ldsDefault":"e4H6yhSYONAzGaTTX_PU","lds-default":"PGGyLxXq8GABIWS4PqmC","white":"VEzIpnTdzRdA2FrxIDdt","blue":"mCskso0AH9xrjPwE7TLA"};